import FormStep from '../../Form/FormStep';
import API from '../../../api';

export default {
	mixins: [FormStep],
	methods: {
		save() {
			if(this.id) {
				return API.updateMember(this.id, this.currentStep, this.formData)
                    .then(response => {
                        console.log('MemberFromStep', response);
                        this.$router.push({ name: 'view-member', params: { member_id: response.id } });
                    })
                    .catch(error => {
                        console.log('MemberFromStep', error);
                    });
			} else {
				return API.createMember(this.formData).then(response => {
					this.$store.commit('form/setId', response.id);
				})
                //     .then(ev => {
				//     console.log('MemberFromStep', ev);
				//     console.log('MemberFromStep', response);
				// 	// this.$router.push({ name: 'view-member', params: { member_id: response.id } });
				// });

			}
		},
	}
}
